import con from '../../../connection';
var path = '/members';
var members = function (url) { return function () { return ({
    get: function (param) { return con.get("" + url + path, param || {}); },
}); }; };
export default members;
